import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import ParticipationForm from "../../components/Participations/ParticipationForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const ParticipationsEdit = ({classes, participations, course, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('participations.edit_participation')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('participations.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Card>
            <CardContent>
                <ParticipationForm
                    values={participations}
                    course={course}
                    formUrl={formUrl}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default ParticipationsEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/participations/Edit.jsx